import { post,put,del,get,get2 } from './axios'

// 관리자관리 CRUD를 나열
export const insertEvalUser = async (params) => {
    const { status, data } = await post("/user/insertEvalUser", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const evalUserList = async (params) => {
    const { status, data } = await get("/user/evalUserList", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const selectPermissions = async (params) => {
    const { status, data } = await get("/user/selectPermissions", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const insertPermissions = async (params) => {
    const { status, data } = await post("/user/insertPermissions", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};